import { ProductTypeFileds, TabItem } from '../interface/interface';
import Tabs from '../components/Tabs';
import ProductTypes from '../components/ProductTypes';
import DosageDiary from './DosageDiary';
import { ProductTypeLabelMapping } from '../constant/constant';

export default function ProductTypeTabs() {
  const tabs: TabItem[] = [
    {
      id: 'tab1',
      label: 'Script Range',
      component: <ProductTypes productType={ProductTypeFileds.SCRIPT_RANGE} />,
    },
    {
      id: 'tabs',
      label: 'Non Script Range',
      component: (
        <ProductTypes productType={ProductTypeFileds.NON_SCRIPT_RANGE} />
      ),
    },
    {
      id: 'tab2',
      label: 'Bundles',
      component: <ProductTypes productType={ProductTypeFileds.BUNDLES} />,
    },
    {
      id: 'tab3',
      label: 'Devices & Accessories',
      component: (
        <ProductTypes productType={ProductTypeFileds.DEVICEANDACCESSORIES} />
      ),
    },
    {
      id: 'tab4',
      label: 'Dosage Diary',
      component: <DosageDiary />,
    },
  ];

  const fetchActiveTab = () => {
    const activeTab = sessionStorage.getItem('selectedProductsTab');
    if (activeTab) {
      return ProductTypeLabelMapping[activeTab as ProductTypeFileds];
    }
    return tabs[0].label;
  };

  const activeTab = fetchActiveTab();

  return <Tabs tabs={tabs} activeTabLabel={activeTab} />;
}
